<span class="option-text"><ng-content /></span>
<sim-checkbox
  class="sim-option-pseudo-checkbox"
  *ngIf="multiple"
  [checked]="selected"
  [disabled]="disabled"
  [inputTabIndex]="-1"
/>
